// Utils
import { Feature } from '@gql';

// UI
import { Button } from '@components/button';
import { Icon, mapFeatureKeyToIconName } from '@components/icon';
import { Typography } from '@components/typography';

type Props = {
  features: Pick<Feature, 'displayName' | 'key'>[];
  showAllEnabled: boolean;
  toggleShowAll: () => void;
};

export const FeaturesSection: React.FC<Props> = ({
  features,
  showAllEnabled,
  toggleShowAll,
}) => {
  const displayToggleButton = features.length > 9;
  const displayList = showAllEnabled ? features : features.slice(0, 8);
  const showText = showAllEnabled ? 'show less' : 'show more';
  return (
    <div className="-mb-2">
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2">
        {displayList.map((feature, index) => (
          <div key={index} className="flex flex-row items-center">
            <Icon
              name={mapFeatureKeyToIconName(feature.key)}
              className="text-primary-main"
            />
            <Typography
              component="span"
              variant="body2"
              variantM="body1"
              className="ml-4"
            >
              {feature.displayName}
            </Typography>
          </div>
        ))}
      </div>
      {displayToggleButton && (
        <div className="flex flex-row justify-end">
          <Button
            size="md"
            onClick={toggleShowAll}
            variant="text"
            className="-mr-3 text-primary-main underline text-xs"
          >
            {showText}
          </Button>
        </div>
      )}
    </div>
  );
};
